export function MarketComingSoon() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-3xl items-center justify-center p-4 sm:p-6">
      <section className="w-full border-2 border-primary bg-background/80 p-8 text-center backdrop-blur-sm sm:p-14">
        <p className="font-mono text-primary/70 text-xs uppercase tracking-[0.2em]">
          Platanus Hack Market
        </p>

        <h1 className="mt-3 font-bold text-4xl text-primary sm:text-5xl">
          Preparando el mercado
        </h1>

        <p className="mx-auto mt-5 max-w-md text-pretty text-primary/70 sm:text-lg">
          Estamos armando todo para que puedas apostar por los proyectos del
          hackathon. Vuelve pronto.
        </p>

        <div className="mt-10 inline-flex items-center gap-2 border-2 border-primary px-4 py-2">
          <span className="size-2 animate-pulse bg-primary" />
          <span className="font-mono text-primary text-xs uppercase tracking-wider">
            Próximamente
          </span>
        </div>
      </section>
    </div>
  );
}
